import { useNavigate, useSearchParams, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import api from 'helpers/api'
import Button from "components/common/Button/Button"
import style from './Intro.module.scss'

const RCProIntro = () => {
  const navigate = useNavigate()
  const previous = localStorage.getItem('RCPro')
  const [ popup, setPopup ] = useState(previous !== null)
  const [ texts, setTexts ] = useState({})
  const { page, savedState } = previous ? JSON.parse(previous) : {}
  const { intro, comeback } = texts
  const [ searchParams ] = useSearchParams()
  const params = useParams() 
  const token = searchParams.get('token')
  const contractType = params.id
  const priceType = searchParams.get('priceType')
  const rateType = searchParams.get('rateType')

  // Get pages texts
  useEffect( () => {
    const getDatas = async () => {
      try{
        const list = await api.get({
          url: `/RCPro/${contractType}/${priceType}/${rateType}/wording`,
          headers: { Authorization: `Bearer ${token}` }
        })

        const datas = {
          estimate:{
            title: "Votre devis RC PRO",
            resume: "Vous êtes {{activity}} avec un chiffre d’affaire prévu de {{turnover}} et des clients en France Métropolitaine.",
            error: "Une erreur ? Modifier vos réponses",
            productName: "Responsabilité Civile Professionnelle",
            description: "Pour couvrir les dommages que vos employés, vos stagiaires ou vous-même pourriez causer aux autres.",
            success: "Votre devis vous a été envoyé !",
            basketTitle: "Votre panier",
            basketButton: "Souscrire",
            editButton: "Valider mes réponses",
            details: [
              {
                //svg: <CircleSmile />,
                title: "Manquements contractuels",
                description: "On vous protège en cas de non-respect d’un contrat"
              },
              {
                //svg: <CircleSmile />,
                title: "Perte de biens confiés",
                description: "On vous couvre si des biens ou des données sont perdus ou endommagés"
              },
              {
                //svg: <CircleSmile />,
                title: "Restitution d’honoraires",
                description: "On prend en charge le remboursement d’un client suite à une réclamation"
              },
              {
                //svg: <CircleSmile />,
                title: "Fautes ou négligences",
                description: "On vous indemnise en cas d’erreur dans l’exécution d’une mission"
              },
              {
                //svg: <CircleSmile />,
                title: "Propriété intelectuelle",
                description: "On vous protège en cas de réclamation pour atteinte aux droits d’auteur ou aux marques"
              },
              {
                //svg: <CircleSmile />,
                title: "Atteinte à votre réputation",
                description: "On prend en charge les frais pour restaurer votre image après une réclamation couverte"
              },
            ]
          },
          activation:{
            title: "Activation du contrat",
            legend: "À quelle date souhaitez-vous activer vos garanties ?"
          },
          frequency:{
            title: "Fréquence de paiement",
            firstDate: "Date de premier prélèvement : {{date}}",
            yearly: "Annuel",
            monthly: "Mensuel"
          },
          resume:{
            title: "Résumé du contrat",
            insured: "Assuré.é",
            documents: "Documents",
            levy: "Prélèvement",
            legalterms: "Je certifie avoir lu, compris et accepté les {{link}}, tels que présentés dans les documents.",
            link: "Termes et Conditions des contrats d’assurance proposés",
            editButton: "Valider mes réponses",
            read: "Lire",
            turnover: "Chiffre d’affaire :",
            start: "À partir du",
            end: "Date de fin d’engagement :"
          },
          payment:{
            title: "Paiement",
            CB: "Par carte",
            transfer: "Par virement bancaire"
          },
          CB:{
            title: "Paiement par carte bancaire"
          },
          transfer:{
            title: "Paiement par virement bancaire"
          },
          signature:{
            title: "Prêt.e pour la signature ?",
            sms: "Par SMS",
            mail: "Par email",
            legalterms: "J’accepte de souscrire à l’assurance Owen et je confirme avoir lu et accepté {{link}} et {{link}}.",
            link1: "la notice d’information sur l’assurance",
            link2: "le document d’information sur le produit"
          },
          oups:{
            title1: "Oups, nous ne pouvons pas vous assurer pour le moment",
            reason1: "Owen ne peut vous assurer car votre entreprise n’existe pas encore. Nous espérons pouvoir vous protéger très bientôt !",
            title2: "Oups, nous ne pouvons pas vous assurer pour le moment",
            reason2: "Owen ne peut vous assurer car les États-Unis et le Canada possèdent une législation spécifique ne nous permettant malheureusement pas de vous prendre en charge à ce jour.",
            title3: "Apparemment vous faites une activité bien spéciale ✨",
            reason3: "Owen ne peut vous assurer car votre activité n’est pas encore prise en charge. Nous espérons pouvoir vous protéger très bientôt !",
            button: "Modifier ma réponse"
          }
        }

        setTexts(list)
      } catch (error) {
        console.log(error)
        throw Error('Failed to get datas')
      }
    }
    getDatas()
  }, [token, contractType, priceType, rateType])

  return popup 
  ? (
    <div className={style.popup}>
      <h1>{comeback?.title} 👀</h1>
      <p>{comeback?.message}</p>
      <Button
        label={comeback?.yes}
        onClick={() => navigate('./'+page, { state: savedState })}
      />
      <Button
        label={comeback?.no}
        onClick={() => setPopup(false)}
      />
    </div>
  ) : (
    <div className={style.content}>
      <h1>{intro?.title} ⏱️</h1>
      <p>{intro?.description}</p>
      <Button
        label={intro?.button}
        onClick={() => navigate(`customer`, { state: {
          texts,
          token,
          contractType,
          priceType,
          rateType
        } })}
      />
    </div>
  )
}

export default RCProIntro